<!--
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-17 13:53:01
 * @LastEditTime: 2020-11-19 10:02:38
 * @FilePath: \ensurance-front\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue